var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 35,
    viewBox: "0 0 24 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ececec;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Forma_1",
    "data-name": "Forma 1",
    className: "cls-1",
    d: "M1335,743a12.278,12.278,0,0,0-12,12.517v9.967a12.01,12.01,0,1,0,24,.038v-10A12.278,12.278,0,0,0,1335,743Zm9.74,22.522a9.749,9.749,0,1,1-19.48-.038v-9.967a9.75,9.75,0,1,1,19.48,0v10ZM1335,752.58a1.147,1.147,0,0,0-1.13,1.159V757.8a1.13,1.13,0,1,0,2.26,0v-4.056A1.147,1.147,0,0,0,1335,752.58Z",
    transform: "translate(-1323 -743)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.05614264b332620ac554682ff631b6a4.svg";
export { ForwardRef as ReactComponent };